import AdminProductsList from './AdminProductsList';

export default AdminProductsList;
